import { Box, BoxProps } from "@mui/material";
import { styled } from "src/styles/fpp-theme/fppStyled";

export const StyledBox = styled(Box)<BoxProps>(({ theme }) => {
    return {
        "& .MuiAccordion-root::before": {
            backgroundColor: theme.palette.neutralGray00.main,
        },
        "& .MuiAccordion-root.Mui-expanded:not(:first-child)::before": {
            position: "absolute",
            left: 0,
            top: "-1px",
            right: 0,
            height: "1px",
            content: '""',
            opacity: 1,
            backgroundColor: theme.palette.neutralGray00.main,
        },
        "& .MuiAccordionDetails-root": {
            marginBottom: theme.spacing(3),
        },
    };
});
